import React, { useContext, useEffect, useRef, useState } from "react";

import {
  Container,
  Stack,
  IconButton,
  Button,
  useMediaQuery,
  Grid,
  Box,
  Divider,
} from "@mui/material";
import RemoveIcon from "@mui/icons-material/Remove";
import AddIcon from "@mui/icons-material/Add";
import {
  useUsdcContract,
  useTokenContract,
  useLpContract,
  useMainnodeContract,
  ToastNotify,
} from "../../ConnectivityAss/hooks";
import silver from "./assets/Silver.svg";
import Gold from "./assets/Gold.svg";
import Diamond from "./assets/Diamond.svg";
import d1 from "./assets/d1.svg";
import { AppContext, gasEstimationForAll } from "../../utils";
import { formatUnits } from "@ethersproject/units";
import Loading from "../../loading";
import { mainNodeAddress } from "../../ConnectivityAss/Environment";

function Jackpot({ initNodes, totalNode1, totalNode2, totalNode3,setConValue }) {
  const mobile = useMediaQuery("(max-width:1050px)");

  const [count, setcount] = useState(1);
  const { account, signer, connect } = useContext(AppContext);

  const mainNodeContract = useMainnodeContract(signer);
  const usdcContract = useUsdcContract(signer);
  const tokenContract = useTokenContract(signer);
  const lpContract = useLpContract(signer);

  const [paymentType, setpaymentType] = useState("con");
  const [loading, setloading] = useState(false);

  const [alertState, setAlertState] = useState({
    open: false,
    message: "",
    severity: undefined,
  });
  const [lpBalance, setlpBalance] = useState(0);
  const [usdcBalance, setusdcBalance] = useState(0);
  const [tokenBalance, settokenBalance] = useState(0);
  const [node1Prices, setnode1Prices] = useState({
    conPrice: 0,
    usdcPrice: 0,
  });
  const [isUsdcEnable, setisUsdcEnable] = useState(false);
  const [node2Prices, setnode2Prices] = useState({
    conPrice: 0,
    usdcPrice: 0,
  });
  const [node3Prices, setnode3Prices] = useState({
    conPrice: 0,
    usdcPrice: 0,
  });
  const [discountPriceUsdc, setdiscountPriceUsdc] = useState(0);
  const [discountUsdcPercentage, setdiscountUsdcPercentage] = useState(0);
  const [discountLpPercentage, setdiscountLpPercentage] = useState(0);
  // index 0 = silver , 1 = gold  ,  2 = Diamand
  const [index, setindex] = useState(0);

  const defaultAddress = "0x0000000000000000000000000000000000000000";
  let refAddress = localStorage.getItem("contexia_refAddress")
    ? localStorage.getItem("contexia_refAddress")
    : defaultAddress;

  const init = async () => {
    try {
      const [
        tokenDecimal,
        lpDecimal,
        usdcDecimal,
        { node1Price, node2Price, node3Price },
        lpDiscount,
        zapfee,
        isEnable,
      ] = await Promise.all([
        tokenContract.decimals(),
        lpContract.decimals(),
        usdcContract.decimals(),
        mainNodeContract.getNodePrices(),
        mainNodeContract.calculateLPDiscount(),
        mainNodeContract.zapFee(),
        mainNodeContract.isUSDCEnabled(),
      ]);
      setdiscountLpPercentage((+lpDiscount / 100).toFixed(2));
      setdiscountUsdcPercentage(((+lpDiscount - +zapfee) / 100).toFixed(2));
      setisUsdcEnable(isEnable);
      if (account) {
        const [balance1, balance2, balance3] = await Promise.all([
          tokenContract.balanceOf(account),
          lpContract.balanceOf(account),
          usdcContract.balanceOf(account),
        ]);
        settokenBalance(formatUnits(balance1, tokenDecimal));
        setlpBalance(formatUnits(balance2, lpDecimal));
        setusdcBalance(formatUnits(balance3, usdcDecimal));
      }
      const [node1UsdcPrice, node2UsdcPrice, node3UsdcPrice] =
        await Promise.all([
          mainNodeContract.getUSDCForCON(node1Price),
          mainNodeContract.getUSDCForCON(node2Price),
          mainNodeContract.getUSDCForCON(node3Price),
        ]);

        // Setting CON value

        setConValue({
          con1:Number((+formatUnits(node1Price, tokenDecimal)).toFixed(0)),
          con2:Number((+formatUnits(node2Price, tokenDecimal)).toFixed(0)),
          con3:Number((+formatUnits(node3Price, tokenDecimal)).toFixed(0))
        })

      setnode1Prices({
        conPrice: (+formatUnits(node1Price, tokenDecimal)).toFixed(0),
        usdcPrice: (+formatUnits(node1UsdcPrice, usdcDecimal)).toFixed(0),
      });

      setnode2Prices({
        conPrice: (+formatUnits(node2Price, tokenDecimal)).toFixed(0),
        usdcPrice: (+formatUnits(node2UsdcPrice, usdcDecimal)).toFixed(0),
      });
      setnode3Prices({
        conPrice: (+formatUnits(node3Price, tokenDecimal)).toFixed(0),
        usdcPrice: (+formatUnits(node3UsdcPrice, usdcDecimal)).toFixed(0),
      });
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    init();
  }, [mainNodeContract]);

  useEffect(async () => {
    if (mainNodeContract) {
      const [priceDiscount, usdcDecimal] = await Promise.all([
        mainNodeContract.getNodeCostWithLPDiscount(
          index.toString(),
          count.toString()
        ),
        usdcContract.decimals(),
      ]);
      setdiscountPriceUsdc(
        (+formatUnits(priceDiscount, usdcDecimal)).toFixed(0)
      );
    }
  }, [index, count]);

  const swiperData = [
    <Box
      sx={{
        display: "flex",
        justifyConten: "center",
        alignItems: "center",
        flexDirection: "column",
      }}
    >
      <img src={silver} alt="" />
      <Box
        width="100%"
        mt="10px"
        sx={{
          fontSize: mobile ? "18px" : "25px",
          fontWeight: "400",
          color: "white",
          textAlign: "center",
          fontFamily: "light",
        }}
      >
        SILVER
      </Box>
    </Box>,
    <Box
      sx={{
        display: "flex",
        justifyConten: "center",
        alignItems: "center",
        flexDirection: "column",
      }}
    >
      <img src={Diamond} alt="" />
      <Box
        mt="10px"
        width="100%"
        sx={{
          fontSize: mobile ? "18px" : "25px",
          fontWeight: "400",
          color: "white",
          textAlign: "center",
          fontFamily: "light",
        }}
      >
        DIAMOND
      </Box>
    </Box>,
    <Box
      sx={{
        display: "flex",
        justifyConten: "center",
        alignItems: "center",
        flexDirection: "column",
      }}
    >
      <img src={Gold} alt="" />
      <Box
        width="100%"
        mt="10px"
        sx={{
          fontSize: mobile ? "18px" : "25px",
          fontWeight: "400",
          color: "white",
          textAlign: "center",
          fontFamily: "light",
        }}
      >
        GOLD
      </Box>
    </Box>,
  ];

  const createNode = async () => {
    try {
      setloading(true);

      if (paymentType === "con") {
        let data = [count.toString(), index.toString(), refAddress];
        console.log(data, "data");
        let fn = mainNodeContract.estimateGas.purchaseWithCON;
        let tx = await mainNodeContract.purchaseWithCON(...data, {
          gasLimit: gasEstimationForAll(account, fn, data),
        });
        await tx.wait();
      } else if (paymentType === "usdc") {
        let data = [count.toString(), index.toString(), refAddress];
        console.log(data, "data");
        let fn = mainNodeContract.estimateGas.purchaseWithLPUsingZap;
        let tx = await mainNodeContract.purchaseWithLPUsingZap(...data, {
          gasLimit: gasEstimationForAll(account, fn, data),
        });
        await tx.wait();
      } else if (paymentType === "lp") {
        let data = [count.toString(), index.toString(), refAddress];
        console.log(data, "data");
        let fn = mainNodeContract.estimateGas.purchaseWithLP;
        let tx = await mainNodeContract.purchaseWithLP(...data, {
          gasLimit: gasEstimationForAll(account, fn, data),
        });
        await tx.wait();
      }
      await initNodes();
      await init();
      setloading(false);
      if (localStorage.getItem("contexia_refAddress")) {
        localStorage.removeItem("contexia_refAddress");
      }
      setAlertState({
        open: true,
        message: `Transaction Successfully completed`,
        severity: "success",
      });
    } catch (error) {
      if (error?.data?.message) {
        setAlertState({
          open: true,
          message: error?.data?.message,
          severity: "error",
        });
      } else {
        setAlertState({
          open: true,
          message: error?.message,
          severity: "error",
        });
      }
      setloading(false);
    }
  };
  const purchaseUSDC = async () => {
    try {
      setloading(true);
      let data = [count.toString(), index.toString(), refAddress];
      console.log(data, "data");
      let fn = mainNodeContract.estimateGas.purchaseWithLPUsingZap;
      let tx = await mainNodeContract.purchaseWithUSDC(...data, {
        gasLimit: gasEstimationForAll(account, fn, data),
      });
      await tx.wait();

      await init();
      await initNodes();
      setloading(false);
      setAlertState({
        open: true,
        message: `Transaction Successfully completed`,
        severity: "success",
      });
    } catch (error) {
      if (error?.data?.message) {
        setAlertState({
          open: true,
          message: error?.data?.message,
          severity: "error",
        });
      } else {
        setAlertState({
          open: true,
          message: error?.message,
          severity: "error",
        });
      }
      setloading(false);
    }
  };
  const approveHandler = async () => {
    try {
      setloading(true);
      const [
        allowance1,
        allowance2,
        allowance3,
        balance1,
        balance2,
        balance3,
        totalLpSupply,
      ] = await Promise.all([
        tokenContract.allowance(account, mainNodeAddress),
        usdcContract.allowance(account, mainNodeAddress),
        lpContract.allowance(account, mainNodeAddress),
        tokenContract.balanceOf(account),
        usdcContract.balanceOf(account),
        lpContract.balanceOf(account),
        lpContract.totalSupply(),
      ]);

      if (paymentType === "con") {
        if (+allowance1 < +balance1) {
          let data = [mainNodeAddress, balance1];
          let fn = tokenContract.estimateGas.approve;
          let tx = await tokenContract.approve(...data, {
            gasLimit: gasEstimationForAll(account, fn, data),
          });
          await tx.wait();
        }
      } else if (paymentType === "usdc") {
        let data = [mainNodeAddress, totalLpSupply];
        let fn = lpContract.estimateGas.approve;
        let tx = await lpContract.approve(...data, {
          gasLimit: gasEstimationForAll(account, fn, data),
        });
        await tx.wait();
        if (+allowance2 < +balance2) {
          let data = [mainNodeAddress, balance2];
          let fn = usdcContract.estimateGas.approve;
          let tx = await usdcContract.approve(...data, {
            gasLimit: gasEstimationForAll(account, fn, data),
          });
          await tx.wait();
        }
      } else if (paymentType === "lp") {
        if (+allowance3 < +balance3) {
          let data = [mainNodeAddress, balance2];
          let fn = lpContract.estimateGas.approve;
          let tx = await lpContract.approve(...data, {
            gasLimit: gasEstimationForAll(account, fn, data),
          });
          await tx.wait();
        }
      }
      await initNodes();
      await init();
      setloading(false);
      setAlertState({
        open: true,
        message: `Approved successfully.`,
        severity: "success",
      });
    } catch (error) {
      if (error?.data?.message) {
        setAlertState({
          open: true,
          message: error?.data?.message,
          severity: "error",
        });
      } else {
        setAlertState({
          open: true,
          message: error?.message,
          severity: "error",
        });
      }
      setloading(false);
    }
  };

  return (
    <>
      {mobile ? (
        <> </>
      ) : (
        <>
          {" "}
          <img
            className="scale"
            src={d1}
            style={{
              position: "absolute",
              marginTop: "480px",
              marginLeft: "-100px",
            }}
            alt=""
          />
        </>
      )}
      <ToastNotify alertState={alertState} setAlertState={setAlertState} />
      <Loading loading={loading} />

      <Box
        className="border"
        width="100%"
        px={mobile ? "28px" : "62px"}
        py={mobile ? "20px" : "35px"}
        sx={{
          background: " rgba(248, 248, 248, 0.1)",
          backdropFilter: "blur(10px)",
          borderRadius: "20px",
          zIndex: "100",
        }}
      >
        <Stack width="100%" direction="column" alignItems={"center"}>
          <Box
            width="100%"
            sx={{
              fontSize: mobile ? "16px" : "20px",
              fontWeight: "600",
              color: "white",
              textAlign: "center",
              fontFamily: "semi",
            }}
          >
            JACKPOTS
          </Box>
          <Divider
            sx={{
              width: "100%",
              height: "1px",
              background: "white",
            }}
          />
          <Box
            mt={"40px"}
            width="100%"
            sx={{
              fontSize: mobile ? "26px" : "30px",
              fontWeight: "400",
              color: "#FAA631",
              textAlign: "center",
              fontFamily: "light",
            }}
          >
            PURCHASE A JACKPOT
          </Box>
          <Box
            width="100%"
            sx={{
              fontSize: mobile ? "16px" : "18px",
              fontWeight: "400",
              color: "white",
              textAlign: "center",
              fontFamily: "regular",
            }}
          >
            Earn Perpetual $CON Rewards!
          </Box>

          <Box maxWidth={"350px"} width="100%">
            <Stack
              direction="row"
              alignItems={"center"}
              justifyContent="space-between"
            >
              <Box>
                <IconButton
                  onClick={() => {
                    if (index === 0) {
                      setindex(2);
                    } else {
                      setindex(index - 1);
                    }
                  }}
                  sx={{
                    color: "white",
                    "&:hover": {
                      color: "#FAA631",
                    },
                  }}
                  onSlideChange={() => console.log("slide change")}
                  onSwiper={(swiper) => console.log(swiper)}
                >
                  <i class="fa-solid fa-arrow-left"></i>
                </IconButton>
              </Box>
              <Box my={"20px"}>{swiperData[index]}</Box>
              <Box>
                <IconButton
                  onClick={() => {
                    if (index === 2) {
                      setindex(0);
                    } else {
                      setindex(index + 1);
                    }
                  }}
                  sx={{
                    color: "white",
                    "&:hover": {
                      color: "#FAA631",
                    },
                  }}
                >
                  <i class="fa-solid fa-arrow-right"></i>
                </IconButton>
              </Box>
            </Stack>
          </Box>

          <Box maxWidth={"300px"} width="100%">
            <Stack
              direction={"row"}
              alignItems="center"
              justifyContent={"space-between"}
            >
              <Box
                sx={{
                  fontSize: mobile ? "16px" : "20px",
                  fontWeight: "400",
                  color: "white",
                  textAlign: "center",
                  fontFamily: "regular",
                }}
              >
                Total : {totalNode1 + totalNode2 + totalNode3}
              </Box>
              <Box
                sx={{
                  fontSize: mobile ? "16px" : "20px",
                  fontWeight: "400",
                  color: "white",
                  textAlign: "center",
                  fontFamily: "regular",
                }}
              >
                Available : 0
              </Box>
            </Stack>
            <Stack
              mt="10px"
              px="20px"
              direction={"row"}
              alignItems="center"
              justifyContent={"space-between"}
            >
              <IconButton
                onClick={() => {
                  if (count > 1) {
                    setcount(count - 1);
                  }
                }}
              >
                <Box
                  sx={{
                    width: "39px",
                    height: "39px",
                    background: "#E30613",
                    borderRadius: "50px",
                    color: "white",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <RemoveIcon />
                </Box>
              </IconButton>

              <Box
                sx={{
                  width: "80px",
                  height: "88px",
                  background: "#FAA631",
                  borderRadius: "20px",
                  color: "white",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: mobile ? "30px" : "50px",
                }}
              >
                {count}
              </Box>
              <IconButton
                onClick={() => {
                  setcount(count + 1);
                }}
              >
                <Box
                  sx={{
                    width: "39px",
                    height: "39px",
                    background: "#E30613",
                    borderRadius: "50px",
                    color: "white",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <AddIcon />
                </Box>
              </IconButton>
            </Stack>
          </Box>
          <Box
            mt="30px"
            maxWidth={"400px"}
            width="100%"
            sx={{ fontFamily: "regular" }}
          >
            <Stack
              direction={"row"}
              alignItems="center"
              justifyContent={"space-between"}
            >
              <Box
                sx={{
                  fontSize: mobile ? "16px" : "20px",
                  fontWeight: "400",
                  color: "white",
                  textAlign: "center",
                }}
              >
                <span
                  style={{
                    color: "#FAA631",
                  }}
                >
                  Jackpot cost :
                </span>
                {index === 0
                  ? node1Prices.conPrice
                  : index === 1
                  ? node2Prices.conPrice
                  : node3Prices.conPrice}{" "}
                CON
              </Box>
              <Box
                sx={{
                  fontSize: mobile ? "16px" : "20px",
                  fontWeight: "400",
                  color: "white",
                  textAlign: "center",
                }}
              >
                <span
                  style={{
                    color: "#FAA631",
                  }}
                >
                  CON :
                </span>
                {(+tokenBalance).toFixed(0)}
              </Box>
            </Stack>
            <Stack
              direction={"row"}
              alignItems="center"
              justifyContent={"space-between"}
            >
              <Box
                sx={{
                  fontSize: mobile ? "16px" : "20px",
                  fontWeight: "400",
                  color: "white",
                  textAlign: "center",
                }}
              >
                <span
                  style={{
                    color: "#FAA631",
                  }}
                >
                  Price :
                </span>
                {index === 0
                  ? node1Prices.usdcPrice
                  : index === 1
                  ? node2Prices.usdcPrice
                  : node3Prices.usdcPrice}{" "}
                $
              </Box>
              <Box
                sx={{
                  fontSize: mobile ? "16px" : "20px",
                  fontWeight: "400",
                  color: "white",
                  textAlign: "center",
                }}
              >
                <span
                  style={{
                    color: "#FAA631",
                  }}
                >
                  USDC :
                </span>
                {(+usdcBalance).toFixed(0)}$
              </Box>
            </Stack>
            <Stack
              direction={"row"}
              alignItems="center"
              justifyContent={"space-between"}
            >
              <Box
                sx={{
                  fontSize: mobile ? "16px" : "20px",
                  fontWeight: "400",
                  color: "white",
                  textAlign: "center",
                }}
              >
                <span
                  style={{
                    color: "#FAA631",
                  }}
                >
                  Price (x) :
                </span>
                {index === 0
                  ? count * +node1Prices.usdcPrice
                  : index === 1
                  ? count * +node2Prices.usdcPrice
                  : count * +node3Prices.usdcPrice}{" "}
                $
              </Box>
              <Box
                sx={{
                  fontSize: mobile ? "16px" : "20px",
                  fontWeight: "400",
                  color: "white",
                  textAlign: "center",
                }}
              >
                <span
                  style={{
                    color: "#FAA631",
                  }}
                >
                  LP :
                </span>
                {(+lpBalance).toFixed(5)}
              </Box>
            </Stack>
          </Box>
          <Box
            mt="30px"
            sx={{
              fontSize: mobile ? "16px" : "20px",
              fontWeight: "400",
              color: "white",
              textAlign: "center",
              fontFamily: "regular",
            }}
          >
            Chose Payment Method:
          </Box>
          <Stack
            width="100%"
            direction={mobile ? "column" : "row"}
            alignItems="center"
            justifyContent={"space-around"}
          >
            <Button
              sx={{
                fontSize: mobile ? "15px" : "15px",
                background: paymentType === "con" ? "#E30613" : "white",
                "&:hover": {
                  background: "#E30613",
                  color: "white",
                },
                color: paymentType === "con" ? "white" : "#E30613",
                borderRadius: "10px",
                fontWeight: "600",
                marginTop: mobile ? "10px" : "0px",
                fontFamily: "light",
              }}
              onClick={() => setpaymentType("con")}
            >
              Con
            </Button>
            <Button
              sx={{
                fontSize: mobile ? "15px" : "15px",
                background: paymentType === "usdc" ? "#E30613" : "white",
                "&:hover": {
                  background: "#E30613",
                  color: "white",
                },
                color: paymentType === "usdc" ? "white" : "#E30613",
                borderRadius: "10px",
                fontWeight: "600",
                marginTop: mobile ? "10px" : "0px",
                fontFamily: "light",
              }}
              onClick={() => setpaymentType("usdc")}
            >
              <Box mx="5px">Usdc </Box>
              <Box
                py="5px"
                fontSize="10px"
                px={mobile ? "10px" : "10px"}
                sx={{
                  background: "#FAA631",
                  borderRadius: "9px",
                  color: "white",
                }}
              >
                Discount : {discountUsdcPercentage} %
              </Box>
            </Button>
            <Button
              sx={{
                fontSize: mobile ? "15px" : "15px",
                background: paymentType === "lp" ? "#E30613" : "white",
                "&:hover": {
                  background: "#E30613",
                  color: "white",
                },
                color: paymentType === "lp" ? "white" : "#E30613",
                borderRadius: "10px",
                fontWeight: "600",
                marginTop: mobile ? "10px" : "0px",
                fontFamily: "light",
              }}
              onClick={() => setpaymentType("lp")}
            >
              <Box mx="5px">LP Tokens </Box>
              <Box
                py="5px"
                fontSize="10px"
                px={mobile ? "10px" : "10px"}
                sx={{
                  background: "#FAA631",
                  borderRadius: "9px",
                  color: "white",
                }}
              >
                Discount : {discountLpPercentage} %
              </Box>
            </Button>
          </Stack>
          <Box
            mt="30px"
            sx={{
              fontSize: mobile ? "16px" : "20px",
              fontWeight: "400",
              color: "white",
              textAlign: "center",
              fontFamily: "regular",
            }}
          >
            Paying using{" "}
            {paymentType === "con"
              ? "CON"
              : paymentType === "usdc"
              ? "USDC"
              : paymentType === "lp" && "LP"}
            :
          </Box>
          {account ? (
            <Stack
              direction="row"
              spacing={2}
              alignItems="center"
              justifyContent="center"
              mt={2}
              flexWrap="wrap"
            >
              <Button
                sx={{
                  fontSize: mobile ? "15px" : "25px",
                  background: "#FAA631",
                  "&:hover": {
                    background: "white",
                    color: "#FAA631",
                  },
                  color: "white",
                  borderRadius: "10px",
                  height: "43px",
                  fontFamily: "light",
                  my: 1,
                }}
                onClick={approveHandler}
              >
                {paymentType === "con"
                  ? "APPROVE CON"
                  : paymentType === "usdc"
                  ? "APPROVE USDC"
                  : paymentType === "lp" && "APPROVE LP"}
              </Button>
              <Button
                sx={{
                  fontSize: mobile ? "15px" : "25px",
                  background: "#FAA631",
                  "&:hover": {
                    background: "white",
                    color: "#FAA631",
                  },
                  color: "white",
                  borderRadius: "10px",
                  height: "43px",
                  fontFamily: "light",
                  my: 1,
                }}
                onClick={createNode}
              >
                {paymentType === "con"
                  ? "BUY IN CON"
                  : paymentType === "usdc"
                  ? `ZAP WITH USDC : $${discountPriceUsdc}`
                  : paymentType === "lp" && "BUY IN LP"}
              </Button>
              {paymentType === "usdc" && isUsdcEnable && (
                <Button
                  sx={{
                    fontSize: mobile ? "15px" : "25px",
                    background: "#FAA631",
                    "&:hover": {
                      background: "white",
                      color: "#FAA631",
                    },
                    color: "white",
                    borderRadius: "10px",
                    height: "43px",
                    fontFamily: "light",
                  }}
                  mt={1}
                  onClick={purchaseUSDC}
                >
                  BUY IN USDC
                </Button>
              )}
            </Stack>
          ) : (
            <Button
              sx={{
                fontSize: mobile ? "15px" : "25px",
                width: "100%",
                background: "#FAA631",
                "&:hover": {
                  background: "white",
                  color: "#FAA631",
                },
                color: "white",
                borderRadius: "10px",
                height: "43px",
                marginTop: mobile ? "10px" : "0px",
                fontFamily: "light",
              }}
              onClick={connect}
            >
              CONNECT WALLET
            </Button>
          )}
        </Stack>
      </Box>
    </>
  );
}

export default Jackpot;
